import React from "react";
import { string, arrayOf, object, any } from "prop-types";
import classNames from "classnames/bind";
import { Icon } from "../Icons/Icons";
import * as styles from "./CompareTable.module.scss";

const cx = classNames.bind(styles);

const Cell = ({ data }) => {
	switch (data) {
		case true:
			return <Icon name="checked--o" className={`swg-text-3xl ${cx("check")}`} />;
		case false:
			return <Icon name="minus--o" className={`swg-text-3xl ${cx("dash")}`} />;
		default:
			return data;
	}
};

Cell.propTypes = {
	data: any.isRequired,
};

const CompareTable = ({ title, header, rows }) => (
	<table className={cx("table")}>
		<tr>
			<th className={cx("header")} style={{ textAlign: "left" }}>
				{title}
			</th>
			{header.map(i => (
				<th key={i.title} className={cx("header")}>
					{i.title}
					<span>{i.subtitle}</span>
				</th>
			))}
		</tr>
		{rows.map((r, index) => (
			// eslint-disable-next-line react/no-array-index-key
			<tr key={index}>
				<td className={cx("cell", "description")}>{r.title}</td>
				{r.columns.map((c, index) => (
					<td className={cx("cell", { highlight: r.highlight })}>
						{/* eslint-disable-next-line react/no-array-index-key */}
						<Cell key={index} data={c} />
					</td>
				))}
			</tr>
		))}
	</table>
);

CompareTable.propTypes = {
	rows: arrayOf(object).isRequired,
	header: arrayOf(object).isRequired,
	title: string,
};

CompareTable.defaultProps = {
	title: "",
};

export default CompareTable;
export { CompareTable };
